import {CurrencyRepository} from "./currency.repository";
import {CurrencyRepositoryV2} from "./currency.repository.v2";

export type {CurrencyRepository, GetCurrenciesResult} from "./currency.repository";
export {CurrencyRepositoryV2} from "./currency.repository.v2";

/**
 * Creates the CurrencyRepository.
 *
 * @example
 * const repository = createCurrencyRepository();
 * const currencies = await repository.getCurrencies();
 */
export const createCurrencyRepository = (): CurrencyRepository => {
  return new CurrencyRepositoryV2();
};
